module.exports = __webpack_public_path__ + "img/Micronesia.f4dfcdb4.png";